/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { NotificationsControllerMarkAsReadMutationResponse, NotificationsControllerMarkAsRead401, NotificationsControllerMarkAsRead403, NotificationsControllerMarkAsRead404 } from "../../models/notificationsController/NotificationsControllerMarkAsRead";

function getNotificationsControllerMarkAsReadUrl() {
  const res = { method: 'PATCH', url: `/api/v1/notifications` as const }  
  return res
}

/**
 * @description Mark a specific notification as read. User can only mark their own notifications.
 * @summary Mark a notification as read
 * {@link /api/v1/notifications}
 */
export async function notificationsControllerMarkAsRead(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<NotificationsControllerMarkAsReadMutationResponse, ResponseErrorConfig<NotificationsControllerMarkAsRead401 | NotificationsControllerMarkAsRead403 | NotificationsControllerMarkAsRead404>, unknown>({ method : "PATCH", url : getNotificationsControllerMarkAsReadUrl().url.toString(), ... requestConfig })  
  return res.data
}